import { render, staticRenderFns } from "./RequestCurrentPricing.vue?vue&type=template&id=6a48fde1"
import script from "./RequestCurrentPricing.ts?vue&type=script&lang=ts&external"
export * from "./RequestCurrentPricing.ts?vue&type=script&lang=ts&external"
import style0 from "./RequestCurrentPricing.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports